export const MEDICAL_LAKE_PARCEL_OFFSET: [number, number, number] = [-0.1710333333, 0, -1.9908333333];

// East-side wall points measured in SceneViewer, 28 Oct 2026. No neighbor window was reported on this side.
export const MEDICAL_LAKE_EAST_SIDE_WALL_CHECK = {
  neighbor: [-2289.89, 739.87, 3760.60] as [number, number, number],
  home: [-2288.70, 739.62, 3765.96] as [number, number, number],
  result: 'No neighboring window reported on this side',
};
export const MEDICAL_LAKE_WEST_SIDE_WALL_CHECK = {
  neighbor: [-2286.90, 739.26, 3785.64] as [number, number, number],
  home: [-2289.85, 739.10, 3780.12] as [number, number, number],
  result: 'No neighboring window reported on this side',
};

// Center of the three measured points marking the intervening House 1 structure.
export const MEDICAL_LAKE_HOUSE1_OCCLUSION_POINT: [number, number, number] = [-2255.9833, 739.7067, 3752.4533];

export type WindowPoint = [number, number, number];
export interface PrivacyWindow {
  id: string;
  label: string;
  corners: WindowPoint[];
  reviewReason?: string;
}

// World XYZ transcribed from the user's SceneViewer measurements, 26 Oct 2026.
export const MEDICAL_LAKE_NEIGHBOR_WINDOW: PrivacyWindow = {
  id: 'neighbor-1', label: 'Window 1',
  corners: [
    [-2321.13, 741.25, 3768.28], [-2321.08, 740.37, 3768.26],
    [-2321.35, 740.21, 3766.80], [-2321.08, 741.24, 3766.99],
  ],
};
export const MEDICAL_LAKE_NEIGHBOR_WINDOWS: PrivacyWindow[] = [
  MEDICAL_LAKE_NEIGHBOR_WINDOW,
  { id: 'neighbor-2', label: 'Rear door 1', corners: [
    [-2321.09, 741.09, 3777.75], [-2321.04, 741.24, 3776.40],
    [-2320.48, 740.10, 3776.71], [-2320.53, 739.69, 3777.91],
  ] },
  { id: 'neighbor-3', label: 'Window 2', corners: [
    [-2320.97, 741.14, 3771.92], [-2321.05, 741.03, 3771.03],
    // Screenshot C/D are opposite bottom corners; follow the opening perimeter.
    [-2321.01, 740.24, 3770.99], [-2320.88, 740.37, 3772.05],
  ] },
  { id: 'neighbor-4', label: 'Window 3', corners: [
    [-2321.05, 741.19, 3775.04], [-2320.88, 741.04, 3774.34],
    [-2320.70, 740.43, 3774.35], [-2320.45, 740.63, 3775.24],
  ] },
  { id: 'front-house-1', label: 'House 1 · window', corners: [
    [-2250.14, 740.29, 3747.16], [-2250.53, 740.56, 3748.79],
    [-2250.19, 739.02, 3748.61], [-2249.90, 738.57, 3747.04],
  ] },
  { id: 'front-house-2', label: 'House 2 · front window', corners: [
    [-2255.27, 738.27, 3778.74], [-2255.18, 738.09, 3780.24],
    [-2255.18, 737.42, 3780.27], [-2255.53, 737.58, 3778.77],
  ] },
  { id: 'front-house-3-window-1', label: 'House 3 · window 1', corners: [
    [-2256.16, 741.13, 3793.44], [-2255.76, 741.04, 3794.81],
    [-2255.74, 739.99, 3794.90], [-2255.81, 740.04, 3793.65],
  ] },
  { id: 'front-house-3-window-2', label: 'House 3 · window 2', corners: [
    [-2255.76, 740.97, 3797.15], [-2256.10, 741.15, 3798.45],
    [-2255.77, 740.06, 3798.61], [-2255.70, 740.01, 3797.29],
  ] },
];
export const MEDICAL_LAKE_FRONT_WINDOWS: PrivacyWindow[] = [
  { id: 'front-1', label: 'Front window 1', corners: [
    [-2284.41, 741.15, 3778.68], [-2284.34, 741.31, 3776.23],
    [-2284.52, 739.45, 3778.57], [-2284.25, 739.63, 3776.31],
  ] },
  { id: 'front-2', label: 'Front window 2', corners: [
    [-2284.43, 738.40, 3778.63], [-2284.50, 738.43, 3776.21],
    [-2284.20, 737.60, 3776.19], [-2284.03, 737.59, 3778.35],
  ] },
  { id: 'front-3', label: 'Front window 3', corners: [
    [-2284.76, 741.03, 3772.47], [-2284.75, 741.11, 3770.83],
    [-2284.55, 740.46, 3770.87], [-2284.29, 740.33, 3772.14],
  ] },
  { id: 'front-4', label: 'Front window 4', corners: [
    [-2284.85, 741.13, 3768.53], [-2284.73, 741.11, 3767.08],
    [-2284.49, 740.43, 3767.09], [-2284.47, 740.35, 3768.50],
  ] },
];

/** Captured neighborhood camera poses for the privacy viewpoints (Three.js world space). */
export const MEDICAL_LAKE_PRIVACY_VIEWPOINTS = {
  house2: {
    position: [-2228.795, 766.742, 3785.818] as [number, number, number],
    lookAt: [-2255.222, 742.943, 3789.275] as [number, number, number],
  },
  house3: {
    position: [-2228.795, 766.742, 3785.818] as [number, number, number],
    lookAt: [-2255.222, 742.943, 3789.275] as [number, number, number],
  },
  rearHouse: {
    position: [-2340.486, 766.742, 3779.474] as [number, number, number],
    lookAt: [-2314.771, 742.157, 3780.151] as [number, number, number],
  },
} as const;

export const MEDICAL_LAKE_PRIVACY_WINDOWS: PrivacyWindow[] = [
  { id: 'rear-1', label: 'Rear glass 1', corners: [
    [-2294.31, 741.06, 3777.16], [-2294.32, 741.03, 3778.67],
    [-2294.81, 739.42, 3778.48], [-2294.58, 739.35, 3777.12],
  ] },
  { id: 'rear-2', label: 'Rear glass 2', corners: [
    [-2294.47, 741.26, 3774.51], [-2294.28, 741.06, 3775.36],
    [-2294.27, 740.07, 3775.48], [-2294.20, 739.98, 3774.61],
  ] },
  { id: 'rear-3', label: 'Rear glass 3', corners: [
    [-2294.39, 741.00, 3771.46], [-2294.40, 740.93, 3772.11],
    [-2294.40, 740.26, 3772.20], [-2294.35, 740.26, 3771.46],
  ] },
  { id: 'rear-4', label: 'Lower rear glass', corners: [
    [-2294.38, 738.44, 3768.68], [-2294.31, 738.38, 3770.32],
    [-2294.70, 736.86, 3770.47], [-2294.82, 736.71, 3768.82],
  ] },
  { id: 'rear-5', label: 'Rear glass 5', corners: [
    [-2295.98, 742.17, 3767.46], [-2294.56, 741.18, 3769.03],
    [-2294.36, 740.14, 3769.12], [-2295.25, 740.69, 3767.63],
  ] },
];
